import React, { useState, useEffect } from "react";
import {Box, Paper, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Button, Stack, IconButton, } from '@mui/material';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import PageLoader from "../../../components/Loader/PageLoader"
import DeleteIcon from '@mui/icons-material/Delete';
import HeaderName from "../../../components/Custom/HeaderName";
import { EditIcon } from "../../../components/Icons";
import { storeEditCustomerDetails } from "../../../redux/Slices/customerSlice";
import Swal from "sweetalert2";
import { deleteOfficeDetails, getOfficeList } from "../../../redux/Thunk/officeThunk";
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};


const OfficeList =() =>{
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const role = localStorage.getItem('role');
  const [selectedRows, setSelectedRows] = useState([]);
  const [search,setSearch] = useState('');
  const [officeList, setOfficeList] = useState([])
   const debouncedSearch = useDebounce(search, 500);
  // pagination
  const [page, setPage] = useState({
    page:0,
    pageSize:10
  })

  useEffect(()=>{
    fetchOffice()
  },[page ,debouncedSearch])

  // get all Office details
  const fetchOffice = async () => {
    setLoader(true)
    dispatch(getOfficeList({page: page.page + 1, limit: page.pageSize, search: debouncedSearch, role:'OfficeAdmin'})).then((res) => {
      setOfficeList(res?.payload?.data)
      setTotalCount(res?.payload?.total)
      setLoader(false)
    })
  };

  const handleRowSelection = (selection) => {
    if (selection?.length === 0) {
      // If no rows selected, clear the selected rows
      setSelectedRows([]);
    } else {
      // Map the selected IDs to their corresponding rows
      // const selectedRows = selection?.map(selectedId =>
      //   facilityList.find(row => row?._id === selectedId)
      // );
      setSelectedRows(selectedRows);
    }
  };

  // Edit Office details
  const handleClickEditOffice =(details) =>{
    navigate('/dashboard/officelist/newoffice', {state:{editDetails:details}})
  }

  // Deleted Customer details
  const handleClickDeleteOffice =(row) =>{
      Swal.fire({ 
        title: `Are you sure you want to delete the selected Office?`,
        showCancelButton: true,
        confirmButtonText: 'Delete',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: () => {
          return dispatch(deleteOfficeDetails({Id: row?.OfficeId, type:'OfficeAdmin'})).then((res)=>{
            if (res?.payload?.success === true && res?.payload?.warning === true) {
              Swal.fire('Warning!', res?.payload?.message, 'warning');
              fetchOffice()
              setSelectedRows([])
            }else if(res?.payload?.success === true){
              Swal.fire('Deleted!', res?.payload?.message, 'delete');
              fetchOffice()
              setSelectedRows([])
            }else{
              Swal.fire('Error!', res?.payload?.message, 'error');
            }
          });
        },
      });
  }

  const columns = [
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Sr.No',
      align:'center',
      headerName: 'Sr. No',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', padding:1, alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{textAlign:'left',}}>
              {page?.page * page?.pageSize + params.api.getAllRowIds().indexOf(params.id)+1}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.25,
      minWidth: 100,
      field: 'OfficeId',
      headerName: 'Id',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'left' }}>
            <Typography noWrap variant='body2' sx={{textAlign:'left',}}>
              {row?.OfficeId}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.4,
      minWidth: 150,
      field: 'Office Name',
      headerName: 'Office Name',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.OfficeName || '--'}
            </Typography>
          </Box>
        )
      }
    }, 
    {
      flex: 0.4,
      minWidth: 180,
      field: 'Admin Name',
      headerName: 'Admin Name',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.AdminName || '--'}
            </Typography>
          </Box>
        )
      }
    },
    {
        flex: 0.55,
        minWidth: 200,
        field: 'Email',
        align:'center',
        headerName: 'Email',
        renderCell: params => {
          const { row } = params
    
          return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
                {row?.Email || '--'}
              </Typography>
            </Box>
          </>
          )
        }
    },
    {
        flex: 0.35,
        minWidth: 120,
        field: 'Mobile Number',
        align:'center',
        headerName: 'Mobile Number',
        renderCell: params => {
        const { row } = params
          return (<>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.Mobile || '--'}
            </Typography>
          </Box>
          </>
          )
        }
    },
    {
      flex: 0.5,
      minWidth: 220,
      field: 'Address',
      align:'center',
      headerName: 'Address',
      renderCell: params => {
        const { row } = params
  
        return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.Address || '--'}
            </Typography>
          </Box>
        </>
        )
      }
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Action',
      headerName: 'Action',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2'>
                <IconButton id='edit' onClick={() => handleClickEditOffice(row)}><EditIcon w={18} h={18} /></IconButton>
                <IconButton id='delete' onClick={()=> handleClickDeleteOffice(row)}><DeleteIcon fontSize="medium" style={{color:'#04AB44'}}/></IconButton>
              </Typography>
            </Box>
          </Box>
        )
      }
    },    
  ]

    return(
        <>
          <div style={{display:'flex', flexDirection:'column', flexGrow: 1}}>
            {/* <Header /> */}
            { loader ? <PageLoader /> : 
              <Grid container style={{padding:'0px 10px', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>   
                <Grid size={{ xs: 12, sm: 12, md: 12, lg:12 }}>
                  <HeaderName headerName={'Office List'}displaySearch = {true} newForm = {true} createNewForm={()=> navigate('/dashboard/officelist/newoffice')} onClickBackButton={()=> navigate("/dashboard")} setSearch ={setSearch} search={search}/>
                  <div className="custom-data-grid-container_table">
                    <DataGrid
                      sx={{
                        borderRadius: "31px",
                        overflow: "auto",
                      }}
                      style={{ width: '100%' }}
                      pagination
                      // checkboxSelection
                      rows={officeList}
                      rowHeight={55}
                      rowCount={totalCount}
                      getRowId={param=> param._id}
                      columns={columns}
                      paginationModel={page}
                      sortingMode='server'
                      paginationMode='server'
                      pageSizeOptions={[10, 50, 100]}
                      onPaginationModelChange={(newPage)=>setPage(newPage)}
                      className="custom-data-grid"
                      selectionModel={selectedRows ? [selectedRows] : []}
                      onRowSelectionModelChange={handleRowSelection}
                      initialState={{
                        totalCount,
                        pagination: { paginationModel: {page:1, pageSize: 10}},
                      }}
                      disableRowSelectionOnClick
                      disableColumnMenu
                      disableColumnFilter
                      disableColumnSorting
                    />
                  </div>
                </Grid>
              </Grid>
            }
          </div>
        </>
    )
}

export default OfficeList